import api from "../../api";
import { formatArrayToElSelect } from "./../../utils";

const state = {
  status: "",
  list: [],
  list_products: [],
  products: []
};

const getters = {
  isLoading: (state) => state.status === "loading",
  list_products: (state) =>
    formatArrayToElSelect(state.list, { label: "Description" }),
  getProductSelector: (state) => {
    return formatArrayToElSelect(state.products, {
      label: "Description"
    });
  }
};

const actions = {
  all: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/interactions/GetProducts", {
          params: {
            CompanyId: rootState.user.user.CompanySelected
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  fetchProducts: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/products/GetProductsByCompany", {
          params: {
            company: rootState.user.user.CompanySelected
          }
        })
        .then((resp) => {
          commit("success");
          commit("SET_PRODUCTS", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  success: (state) => {
    state.status = "success";
  },
  loading: (state) => {
    state.status = "loading";
  },
  error: (state) => {
    state.status = "error";
  },
  list: (state, data) => {
    state.list = data;
  },
  SET_PRODUCTS: (state, payload) => {
    state.products = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
